var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"movie-box page-absolute page-background",style:(_vm.layOutStyle)},[_c('div',{staticClass:"top",style:(_vm.topStyle)}),_c('div',{staticClass:"bottom",style:(_vm.botStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }